exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn.btn-delete {\n  background: #f05751;\n  color: white;\n}", ""]);

// exports
